import React from "react";
import SectionHeadingBadge from "../../components/badges/SectionHeadingBadge";
import Discover from "../../assets/icons/globe.svg";
import TalentFirstMindset from "../../assets/icons/productiveMind.svg";
import FutureFocused from "../../assets/icons/FutureFocused.svg";
import { Card } from "react-bootstrap";
function WhyGeesez() {
  const advantageCards = [
    {
      iconBg: "#ffa900",
      iconSrc: TalentFirstMindset,
      title: "Product-First Mindset",
      description:
        "We think like founders, not just developers. Our internal innovation labs are constantly building and testing new products, giving us firsthand experience in what it takes to succeed. We bring this owner's mindset to every client project.",
    },
    {
      iconBg: "#6b66da",
      iconSrc: Discover,
      title: "Deep Expertise in Adaptation",
      description:
        'Our unique "Global-to-Local" framework is our superpower. We have a proven process for deconstructing complex business models and rebuilding them for local success, minimizing your risk and maximizing your potential for market fit.',
    },
    {
      iconBg: "#a066da",
      iconSrc: FutureFocused,
      title: "Future-Focused Technology & Talent",
      description:
        "We live at the intersection of today's trends and tomorrow's technology. Our expertise in deep tech (AI, ML, Data Science) ensures your product is not just current, but future-ready. This commitment to innovation is fueled by our ecosystem, where we nurture the next generation of tech talent, giving our partners an unparalleled advantage.",
    },
  ];
  return (
    <div className="container d-flex flex-column justify-content-center vh-100 align-items-center gap-3 mb-3">
      <SectionHeadingBadge text="Why Geesez" />
      <h1 className="text-white oswald-Bold font-48 text-transform-uppercase text-center">
        The Geesez Advantage
      </h1>
      <p className="font-14 poppins-light color-theme-sub text-center">
        Three core strengths that set us apart in the competitive landscape
      </p>
      <div className="d-lg-flex gap-3 d-block">
        {advantageCards.map((card, index) => (
          <Card
            key={`advantage-card-${index}`}
            className="rounded border-none bg-dark px-3 py-4 w-45 cursor-pointer mt-2 mt-lg-0"
          >
            <div className="d-flex flex-column align-items-center gap-3 px-6 py-3 h-100">
              <div
                className={`d-flex algin-items-center justify-content-center p-2 rounded `}
                style={{ background: card.iconBg, width: "fit-content" }}
              >
                <img
                  className="w-[38px] h-[38px]"
                  alt="Feature icon"
                  src={card.iconSrc}
                />
              </div>

              <div className="d-flex flex-column align-items-center gap-2 w-100">
                <h3 className="poppins-semibold text-white text-base font-16 text-center">
                  {card.title}
                </h3>

                <p className="text-white text-white font-14 poppins-light text-center ">
                  {card.description}
                </p>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default WhyGeesez;
